import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d0bb5fc2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "table__tag"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "flex_box"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

const _hoisted_5 = ["onClick"];
import { getTextWidth } from '@/utils';
import { ref, nextTick } from 'vue';
const __default__ = {
  name: 'TagType'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    languageOptions: {
      type: Array,
      default: () => []
    },
    currentActive: {
      type: [String, Number],
      default: -1
    },
    buttonsList: {
      type: Array,
      default: () => []
    },
    showAddButton: {
      type: Boolean,
      default: true
    },
    currentSelectKey: {
      type: String,
      default: 'id'
    }
  },
  emits: ['update:modelValue', 'onTagClick', 'on-add-click', 'select-change', 'handleCommand'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const tagRef = ref(null);
    const tagInnerRef = ref(null);
    const showArrowIcon = ref(false);

    const moveTo = offset => {
      const scrollLeft = tagRef.value.scrollLeft;
      tagRef.value.scrollLeft = scrollLeft + offset; // console.log(scrollLeft + offset, tagRef.value.scrollLeft);
    };

    const themeInnerMouseOver = () => {
      if (tagInnerRef.value.scrollWidth > tagRef.value.offsetWidth) {
        // console.log('超出容器宽度');
        showArrowIcon.value = true;
      }
    };

    const themeInnerMouseLeave = () => {
      showArrowIcon.value = false;
    };

    const onTagClick = (item, index) => {
      emit('onTagClick', item, index);
    };

    const handleAdd = () => {
      emit('on-add-click');
    };

    const stopClick = () => {};

    const handleCommand = (item, type) => {
      emit('handleCommand', {
        type,
        data: item
      });
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '16px',
        fontWeight: 'bold'
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    watch(() => props.currentActive, val => {
      nextTick(() => {
        let activeItem = tagRef.value.querySelectorAll('.active')[0];
        const halfWidth = tagRef.value.offsetWidth / 2;

        if (activeItem.offsetLeft > halfWidth) {
          tagRef.value.scrollLeft = activeItem.offsetLeft - halfWidth + activeItem.offsetWidth / 2;
        } else {
          tagRef.value.scrollLeft = activeItem.scrollLeft;
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("div", {
        class: "tag-warp",
        onMouseover: themeInnerMouseOver,
        onMouseleave: themeInnerMouseLeave
      }, [_createElementVNode("i", {
        style: _normalizeStyle(['visibility:' + (showArrowIcon.value ? '' : 'hidden'), {
          "left": "-20px"
        }]),
        class: "triangle iconfont icon-normal",
        onClick: _cache[0] || (_cache[0] = $event => moveTo(-240))
      }, null, 4), _createElementVNode("div", {
        class: "tag__scroll",
        ref_key: "tagRef",
        ref: tagRef
      }, [_createElementVNode("div", {
        style: {
          "flex": "1"
        },
        ref_key: "tagInnerRef",
        ref: tagInnerRef
      }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['tag__item', index === 0 ? 'first__item' : 'other__item', {
            'active': item[__props.currentSelectKey] + item.type === __props.currentActive
          }]),
          onClick: $event => onTagClick(item, index),
          key: index
        }, [_createElementVNode("div", {
          style: _normalizeStyle([index === __props.currentActive ? 'height: 100%' : '', {
            "width": "100%",
            "display": "flex",
            "align-items": "center",
            "flex-direction": "column"
          }])
        }, [_createElementVNode("div", {
          style: _normalizeStyle([{
            "padding": "2px 0 0 2px"
          }, 'width:' + (index === 0 ? '100%;' : '75%')])
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
          style: _normalizeStyle(['backgroundColor:' + (item.status === 'disable' ? '#aab6bf' : '#56de8f'), {
            "display": "inline-block",
            "margin-right": "3px",
            "border-radius": "50%",
            "width": "10px",
            "height": "10px"
          }])
        }, null, 4), _createElementVNode("span", {
          class: "status_text",
          style: _normalizeStyle(['color:' + (item.status === 'disable' ? '#aab6bf' : '#56de8f'), {
            "font-size": "12px"
          }])
        }, _toDisplayString(item.status === 'disable' ? _ctx.$t('停运') : _ctx.$t('运行')), 5), _createElementVNode("span", {
          style: _normalizeStyle(['backgroundColor:' + (item.status === 'disable' ? '#aab6bf' : '#56de8f'), {
            "display": "inline-block",
            "margin": "0 5px",
            "width": "2px",
            "height": "11px"
          }])
        }, null, 4), _createElementVNode("span", {
          style: _normalizeStyle(['color:' + (item.status === 'disable' ? '#aab6bf' : '#56de8f'), {
            "font-size": "12px"
          }])
        }, _toDisplayString(item.type === 'static' ? _ctx.$t('静态') : _ctx.$t('动态')), 5)]), _hoisted_4], 4), _createElementVNode("div", {
          style: _normalizeStyle([index == 0 ? 'width: 70%;' : 'width: 50%;', {
            "margin-left": "20px",
            "display": "flex",
            "align-items": "center",
            "justify-content": "space-between"
          }])
        }, [_createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.name
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            onMouseover: showTextTip,
            class: "tag-name"
          }, _toDisplayString(item.name), 33)]),
          _: 2
        }, 1032, ["disabled", "content"]), item.icon ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(['iconfont', item.icon])
        }, null, 2)) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
          "show-timeout": 100,
          onClick: _withModifiers(stopClick, ["stop"]),
          onCommand: $event => handleCommand(item, $event)
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              command: "edit"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('编辑')), 1)]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "delete"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("i", {
            onClick: _withModifiers(stopClick, ["stop"]),
            class: "iconfont icon-gengduo fs--26 more__setting"
          }, null, 8, _hoisted_5)]),
          _: 2
        }, 1032, ["onClick", "onCommand"])], 4)], 4)], 10, _hoisted_2);
      }), 128)), __props.showAddButton ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: handleAdd,
        class: "tag__item other__item",
        style: {
          "min-width": "110px",
          "font-size": "20px",
          "margin-left": "-30px"
        }
      }, " + ")) : _createCommentVNode("", true)])], 512)], 512), _createElementVNode("i", {
        style: _normalizeStyle(['visibility:' + (showArrowIcon.value ? '' : 'hidden'), {
          "right": "-20px"
        }]),
        class: "triangle iconfont icon-ic_chevron_right_px",
        onClick: _cache[1] || (_cache[1] = $event => moveTo(240))
      }, null, 4)], 32);
    };
  }

});